const FECHAS = (() => {
  const dates = [];
  const start = new Date('2024-01-02T00:00:00');
  for (let i = 0; i < 168; i++) {
    const d = new Date(start.getTime() + i * 3600 * 1000);
    dates.push(d.toISOString().slice(0, 19).replace('T', ' '));
  }
  return dates;
})();

function genInstantaneo(base, noise) {
  return FECHAS.map((_, i) => parseFloat((base + Math.sin(i / 6) * noise + Math.random() * 0.2).toFixed(2)));
}

function genAcumulado(start, step) {
  const vals = [];
  let acc = start;
  for (let i = 0; i < FECHAS.length; i++) {
    acc += step + Math.random() * 0.5;
    vals.push(parseFloat(acc.toFixed(1)));
  }
  return vals;
}

function genNegativo(step) {
  const vals = [];
  let acc = 0;
  for (let i = 0; i < FECHAS.length; i++) {
    if (i % 12 === 0) acc += step + Math.random() * 0.2;
    vals.push(parseFloat(acc.toFixed(1)));
  }
  return vals;
}

const COLORS = {
  25: '#FFE0B2',
  26: '#1976D2',
  27: '#80DEEA',
  28: '#9FA8DA',
  30: '#E6EE9C',
};

const caudalSensoresData = [
  // --- Grupo 1: 01DD06 ---
  {
    id: 201,
    id_tipo_sensor: 26,
    nombre_tipo_sensor: 'Caudal instantáneo',
    value: '2.45',
    unidades: 'm³/h',
    id_remote: '01DD06',
    nombre_remote: '01DD06',
    color_front_end: COLORS[26],
    historico: { fecha_registro: FECHAS, values: genInstantaneo(2.4, 1.2) },
  },
  {
    id: 202,
    id_tipo_sensor: 27,
    nombre_tipo_sensor: 'Caudal acumulado',
    value: '1037.90',
    unidades: 'm³',
    id_remote: '01DD06',
    nombre_remote: '01DD06',
    color_front_end: COLORS[27],
    historico: { fecha_registro: FECHAS, values: genAcumulado(900, 1.1) },
  },
  {
    id: 203,
    id_tipo_sensor: 28,
    nombre_tipo_sensor: 'Caudal negativo',
    value: '14.20',
    unidades: 'm³',
    id_remote: '01DD06',
    nombre_remote: '01DD06',
    color_front_end: COLORS[28],
    historico: { fecha_registro: FECHAS, values: genNegativo(1.4) },
  },
  {
    id: 210,
    id_tipo_sensor: 25,
    nombre_tipo_sensor: 'Batería contador agua',
    value: '3.51',
    unidades: 'V',
    id_remote: '01DD06',
    nombre_remote: '01DD06',
    color_front_end: COLORS[25],
    historico: { fecha_registro: FECHAS, values: FECHAS.map(() => parseFloat((3.45 + Math.random() * 0.08).toFixed(3))) },
  },
  {
    id: 209,
    id_tipo_sensor: 30,
    nombre_tipo_sensor: 'Horas de funcionamiento',
    value: '498',
    unidades: 'h',
    id_remote: '01DD06',
    nombre_remote: '01DD06',
    color_front_end: COLORS[30],
    historico: { fecha_registro: FECHAS, values: genAcumulado(330, 1) },
  },

  // --- Grupo 2: 011B06 ---
  {
    id: 204,
    id_tipo_sensor: 26,
    nombre_tipo_sensor: 'Caudal instantáneo',
    value: '0.82',
    unidades: 'm³/h',
    id_remote: '011B06',
    nombre_remote: '011B06',
    color_front_end: COLORS[26],
    historico: { fecha_registro: FECHAS, values: genInstantaneo(0.8, 0.5) },
  },
  {
    id: 205,
    id_tipo_sensor: 27,
    nombre_tipo_sensor: 'Caudal acumulado',
    value: '542.60',
    unidades: 'm³',
    id_remote: '011B06',
    nombre_remote: '011B06',
    color_front_end: COLORS[27],
    historico: { fecha_registro: FECHAS, values: genAcumulado(480, 0.6) },
  },
  {
    id: 207,
    id_tipo_sensor: 28,
    nombre_tipo_sensor: 'Caudal negativo',
    value: '8.50',
    unidades: 'm³',
    id_remote: '011B06',
    nombre_remote: '011B06',
    color_front_end: COLORS[28],
    historico: { fecha_registro: FECHAS, values: genNegativo(0.8) },
  },
  {
    id: 208,
    id_tipo_sensor: 30,
    nombre_tipo_sensor: 'Horas de funcionamiento',
    value: '312',
    unidades: 'h',
    id_remote: '011B06',
    nombre_remote: '011B06',
    color_front_end: COLORS[30],
    historico: { fecha_registro: FECHAS, values: genAcumulado(144, 1) },
  },
  {
    id: 206,
    id_tipo_sensor: 25,
    nombre_tipo_sensor: 'Batería contador agua',
    value: '3.42',
    unidades: 'V',
    id_remote: '011B06',
    nombre_remote: '011B06',
    color_front_end: COLORS[25],
    historico: { fecha_registro: FECHAS, values: FECHAS.map(() => parseFloat((3.35 + Math.random() * 0.1).toFixed(3))) },
  },
];

export function getCaudalSensores() {
  return caudalSensoresData;
}
